const maxFileSize = 5242880;

export const isFileTooLarge = (file: File) => file.size > maxFileSize;
